import { useEffect } from "react";
import BeforeAfter from "@/components/BeforeAfter";
import Reveal from "@/components/SectionReveal";
import { useSeo, localBusinessJsonLd } from "@/lib/seo";
import { SITE } from "@/data/site";

export default function GalleryPage() {
  useSeo({
    title: "Green Pool Cleanup — Before & After Gallery",
    description:
      "See real Tampa Bay green pool cleanup transformations. From algae bloom to crystal clear — before-and-after photos from Clearwater, Palm Harbor, Westchase, Carrollwood, and across Tampa Bay.",
    path: "/gallery",
    image: SITE.logo,
    jsonLd: localBusinessJsonLd(),
  });
  useEffect(() => { window.scrollTo({ top: 0 }); }, []);

  return (
    <main className="bg-white">
      <section className="pt-32 sm:pt-44 pb-10 bg-gradient-to-br from-sky-50 via-white to-amber-50/40">
        <div className="max-w-7xl mx-auto px-6 sm:px-10">
          <Reveal>
            <p className="text-xs tracking-[0.22em] uppercase font-bold text-sky-700">
              Before &amp; After Gallery
            </p>
            <h1 className="mt-3 font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-slate-900 max-w-4xl">
              Green pool to crystal clear — real Tampa Bay results.
            </h1>
            <p className="mt-5 max-w-2xl text-slate-700 text-lg">
              Real pools, real customers, real transformations across Tampa Bay.
            </p>
          </Reveal>
        </div>
      </section>

      <BeforeAfter />
    </main>
  );
}
